import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { memo } from 'react';
import { selectErroriCarrelloByTicket, selectPuntataScommessaByType, selectTipo } from '../carrelloSelectors';
import { updatePuntataSistema } from './actions';

import { isDivisible } from 'features/sport';
import { CarrelloInputImporto } from '../carrelloInputImporto';
import { selectedSistema } from '../carrelloSlice';
import styles from './CarrelloEditQuotaInputSistema.module.scss';

export type CarrelloEditQuotaInputSistemaProps = {
  defaultValue?: number;
  sistema: boolean;
  idSistema: string;
  isDisabled?: boolean;
  handleChangeQuotaInput: (_e: React.MouseEvent<HTMLElement>) => void;
};
export const CarrelloEditQuotaInputSistema = memo(function CarrelloEditQuotaInputSistema({
  sistema,
  idSistema,
  isDisabled,
  handleChangeQuotaInput,
}: CarrelloEditQuotaInputSistemaProps) {
  const dispatch = useAppDispatch();

  const carrelloType = useTypedSelector(selectTipo);
  const puntata = useTypedSelector((state) => selectPuntataScommessaByType(state, carrelloType, idSistema));
  const erroriCarrello = useTypedSelector((state) => selectErroriCarrelloByTicket(state, carrelloType));

  return (
    <div className={`${styles.container}`}>
      <CarrelloInputImporto
        isDisabled={isDisabled}
        key={idSistema}
        puntata={puntata}
        erroriCarrello={erroriCarrello}
        setPuntataInputValue={(value: number) => {
          if (isDivisible(value) && sistema && idSistema) {
            dispatch(updatePuntataSistema(value, sistema, idSistema, true));
          }
        }}
        onClick={(e) => {
          dispatch(selectedSistema(idSistema));
          if (isDisabled) {
            handleChangeQuotaInput(e);
          }
        }}
        handleChangeQuotaInput={handleChangeQuotaInput}
      />
    </div>
  );
});
